import { cn } from '@/lib/utils'

/* ============================================================
   StatusBadge — Shared status pill using semantic design tokens
   Replaces duplicated STATUS_PILL maps across admin pages.
   Automatically adapts to dark mode via CSS variables.
   ============================================================ */

const STATUS_MAP: Record<string, string> = {
  confirmed: 'bg-status-success-bg text-status-success-text border-status-success-border',
  completed: 'bg-status-success-bg text-status-success-text border-status-success-border',
  pending: 'bg-status-warning-bg text-status-warning-text border-status-warning-border',
  cancelled: 'bg-status-error-bg text-status-error-text border-status-error-border',
  no_show: 'bg-status-neutral-bg text-status-neutral-text border-status-neutral-border',
}

const FALLBACK = 'bg-status-neutral-bg text-status-neutral-text border-status-neutral-border'

type StatusBadgeProps = {
  status: string
  className?: string
}

export default function StatusBadge({ status, className }: StatusBadgeProps) {
  const normalized = status.toLowerCase()
  const classes = STATUS_MAP[normalized] ?? FALLBACK

  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full border px-2.5 py-1 text-xs font-medium capitalize',
        classes,
        className
      )}
    >
      {normalized.replace(/_/g, ' ')}
    </span>
  )
}

export { STATUS_MAP }
